import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { largeParagraphStyle, sansParagraphStyle, textContainer, titleContainer, } from './textStyles';
export default function Text({ children }) {
    return _jsx("div", { css: textContainer, children: children });
}
export function Title({ children }) {
    return _jsx("h1", { css: titleContainer, children: children });
}
export function LargeParagraph({ children }) {
    return _jsx("p", { css: largeParagraphStyle, children: children });
}
export function SansParagraph({ children }) {
    return _jsx("p", { css: sansParagraphStyle, children: children });
}
